export const getStoreLocatorMarkerIcon = (icon) => ({
    url: icon,
});
//# sourceMappingURL=getStoreLocatorMarkerIcon.js.map